import History from 'history';
import { FCMMessage } from './ipc_types';
import { PaymentRedirect } from './redirect_types';
import { Optional } from './types';

export let HISTORY: History.History;
export let APP_VERSION = 'unconfigured';
export let PLATFORM = 'unconfigured';
export let FCM_TOKEN: Optional<string>;
export let INITIAL_NOTIFICATION: Optional<FCMMessage>;
export let PAYMENT_REDIRECT: Optional<PaymentRedirect>;
export let INITIAL_LOAD_COMPLETE = false;

type ConfigurationOpts = {
  history: History.History;
  platform: string;
  version: string;
  fcmToken: Optional<string>;
  initialNotification: Optional<FCMMessage>;
  paymentRedirect: Optional<PaymentRedirect>;
};

export function configure({ history, platform, version, fcmToken, initialNotification, paymentRedirect }: ConfigurationOpts) {
  HISTORY = history;
  PLATFORM = platform;
  APP_VERSION = version;
  FCM_TOKEN = fcmToken;
  INITIAL_NOTIFICATION = initialNotification;
  PAYMENT_REDIRECT = paymentRedirect;
}

export function configureFCMToken(fcmToken: string) {
  FCM_TOKEN = fcmToken;
}

export function configureInitialNotification(initialNotification: FCMMessage) {
  INITIAL_NOTIFICATION = initialNotification;
}

export function configurePaymentRedirect(paymentRedirect: Optional<PaymentRedirect>) {
  PAYMENT_REDIRECT = paymentRedirect;
}

export function configureInitialLoadComplete(loaded: boolean) {
  INITIAL_LOAD_COMPLETE = loaded;
}
